import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE__use_subscription_plans_mjs_fe799776__ from "./use-subscription-plans.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__dialog_mjs_15b9769c__ from "../dialog.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__pricing_card_mjs_2900db3a__ from "./pricing-card.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_9814e660__ from "../../lib/utils.mjs";
const PricingContext = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.createContext)(void 0);
function matchesPriceIds(planPriceIds, targetPriceIds, allowPartialMatch = true) {
    if (!planPriceIds || 0 === planPriceIds.length || 0 === targetPriceIds.length) return false;
    const exactMatch = planPriceIds.length === targetPriceIds.length && planPriceIds.every((id)=>targetPriceIds.includes(id));
    if (exactMatch) return true;
    if (allowPartialMatch) return planPriceIds.some((id)=>targetPriceIds.includes(id));
    return false;
}
function findCurrentPlanIndex(plans, currentPriceIds) {
    return plans.findIndex((plan)=>{
        const allowPartialMatch = "legacy" === plan.id;
        return matchesPriceIds(plan.price.ids, currentPriceIds, allowPartialMatch);
    });
}
const PricingProvider = ({ children, subscription: { data: subscription, isLoading: isLoadingSubscription = false }, scheduledSubscription = null, actions, state, disabled = false, plansUrl })=>{
    const { plans, isLoading: isLoadingPlans, error: plansError } = (0, __WEBPACK_EXTERNAL_MODULE__use_subscription_plans_mjs_fe799776__.useSubscriptionPlans)({
        plansUrl
    });
    const [dialogOptions, setDialogOptions] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(null);
    const [isDialogOpen, setIsDialogOpen] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(false);
    const [isProcessingStripeReturn, setIsProcessingStripeReturn] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(false);
    const currentPlan = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(()=>{
        if (!subscription || 0 === subscription.stripePriceIds.length) return null;
        const matchedPlan = plans.find((plan)=>{
            const allowPartialMatch = "legacy" === plan.id;
            return matchesPriceIds(plan.price.ids, subscription.stripePriceIds, allowPartialMatch);
        });
        if (!matchedPlan) return plans.find((plan)=>"enterprise" === plan.id) || null;
        return matchedPlan;
    }, [
        subscription,
        plans
    ]);
    const scheduledPlan = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(()=>{
        if (!scheduledSubscription?.stripePriceIds || 0 === scheduledSubscription.stripePriceIds.length) return null;
        return plans.find((plan)=>matchesPriceIds(plan.price.ids, scheduledSubscription.stripePriceIds, false)) || null;
    }, [
        scheduledSubscription,
        plans
    ]);
    const hasFeature = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)((featureKey)=>{
        if (disabled || plansError || isLoadingSubscription || isLoadingPlans) return true;
        if (!currentPlan) {
            const featureExistsInAnyPlan = plans.some((plan)=>plan.features.some((f)=>f.key === featureKey));
            return !featureExistsInAnyPlan;
        }
        const feature = currentPlan.features.find((f)=>f.key === featureKey);
        if (!feature) {
            const featureExistsInAnyPlan = plans.some((plan)=>plan.features.some((f)=>f.key === featureKey));
            return !featureExistsInAnyPlan;
        }
        return true === feature.visible;
    }, [
        currentPlan,
        plans,
        disabled,
        plansError,
        isLoadingSubscription,
        isLoadingPlans
    ]);
    const openFeatureGateDialog = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)((options)=>{
        setDialogOptions(options);
        setIsDialogOpen(true);
        options.onOpen?.();
    }, []);
    const handleDialogClose = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)((open)=>{
        setIsDialogOpen(open);
        if (!open) {
            dialogOptions?.onClose?.();
            setDialogOptions(null);
        }
    }, [
        dialogOptions
    ]);
    const featureLabel = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(()=>{
        if (!dialogOptions) return "";
        return plans.flatMap((p)=>p.features).find((f)=>f.key === dialogOptions.featureKey)?.label || dialogOptions.featureKey;
    }, [
        dialogOptions,
        plans
    ]);
    const wrappedOnPlanChange = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(async (planId, priceIds, type)=>{
        if (!actions?.onPlanChange) return;
        if (isProcessingStripeReturn) return void console.warn("[PricingProvider] Blocked subscription attempt during Stripe return processing");
        await actions.onPlanChange(planId, priceIds, type);
    }, [
        actions,
        isProcessingStripeReturn
    ]);
    const value = {
        subscription,
        scheduledSubscription,
        plans,
        currentPlan,
        scheduledPlan,
        hasFeature,
        isLoading: isLoadingSubscription || isLoadingPlans,
        disabled,
        onPlanChange: disabled ? void 0 : wrappedOnPlanChange,
        onManage: disabled ? void 0 : actions?.onManage,
        loadingPriceIds: state?.loadingPriceIds,
        openFeatureGateDialog,
        isProcessingStripeReturn,
        setIsProcessingStripeReturn
    };
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(PricingContext.Provider, {
        value: value,
        children: [
            children,
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__dialog_mjs_15b9769c__.Dialog, {
                open: isDialogOpen,
                onOpenChange: handleDialogClose,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__dialog_mjs_15b9769c__.DialogContent, {
                    className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_9814e660__.cn)("sm:max-w-6xl max-h-[95dvh] overflow-y-auto", dialogOptions?.className),
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__dialog_mjs_15b9769c__.DialogHeader, {
                            children: [
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__dialog_mjs_15b9769c__.DialogTitle, {
                                    children: [
                                        "Upgrade to access ",
                                        featureLabel
                                    ]
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__dialog_mjs_15b9769c__.DialogDescription, {
                                    children: currentPlan ? `Your current plan (${currentPlan.title}) doesn't include this feature` : "Choose a plan to unlock this feature"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                            className: "mt-10 mb-2",
                            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__pricing_card_mjs_2900db3a__.PricingGrid, {
                                pricing: {
                                    plans,
                                    subscription: {
                                        priceIds: subscription?.stripePriceIds || []
                                    }
                                },
                                options: {
                                    filterByFeature: dialogOptions?.featureKey
                                }
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const usePricing = ()=>{
    const context = (0, __WEBPACK_EXTERNAL_MODULE_react__.useContext)(PricingContext);
    if (void 0 === context) throw new Error("usePricing must be used within a PricingProvider");
    return context;
};
export { PricingProvider, findCurrentPlanIndex, matchesPriceIds, usePricing };
